import { TNavigatableFolderType } from '../types/dialogs.types';
import { isTFolder, IFolder, TRootItems, EFolderType, TPath } from '../types/folders.types';
import { TItem } from '../types/items.types';

// Immediate parent = last entry of the resolved path (resolvedPath[0] is the product/root).
export const getImmediateParentId = (resolvedPath: TPath): string | undefined =>
  resolvedPath[resolvedPath.length - 1]?._id;

export const isCountryItem = (parent: IFolder): boolean => parent.folderType === EFolderType.COUNTRY;

export const isSnapshotItem = (parent: IFolder): boolean => parent.folderType === EFolderType.SNAPSHOT;

export const isProductFolder = (item: TItem): boolean =>
  item.type === 'FOLDER' && item.folderType === EFolderType.PRODUCT;

// Products the user opened come first, most recent first; the rest keep their name order.
export const sortProductsByRecentlyOpened = (products: TItem[], recentProductIds: string[]): TItem[] => {
  const recentProducts = recentProductIds
    .map((id) => products.find((product) => product._id === id))
    .filter((product): product is TItem => Boolean(product));
  return [...recentProducts, ...products.filter((product) => !recentProducts.includes(product))];
};

export const isNavigatableFolderType = (
  data: IFolder | TRootItems,
  item: TItem,
  navigatableFolderTypes: TNavigatableFolderType[]
): boolean => {
  if (item.path.length === 0)
    // always allow navigation into QM & products; into the countries root only where countries are navigatable
    return item.folderType !== EFolderType.COUNTRY || navigatableFolderTypes.includes('COUNTRY');

  const parentNavigationType: TNavigatableFolderType =
    isTFolder(data) && isCountryItem(data)
      ? 'COUNTRY'
      : isTFolder(data) && isSnapshotItem(data)
        ? 'SNAPSHOT'
        : 'NORMAL';

  const navigationType: TNavigatableFolderType = item.isBlock
    ? 'BLOCK'
    : item.type === 'FOLDER' && item.folderType === EFolderType.COUNTRY
      ? 'COUNTRY'
      : item.type === 'FOLDER' && item.folderType === EFolderType.SNAPSHOT
        ? 'SNAPSHOT'
        : parentNavigationType;
  return navigatableFolderTypes.includes(navigationType);
};
